import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Select } from "primeng/select";
import { ReportParameterBase } from './report-parameter-base';

interface SelectParameterOption {
    value: unknown,
    label: string
}

export interface SelectParameterOptions {
    options: SelectParameterOption[],
}

@Component({
    selector: 'app-select-parameter',
    imports: [FormsModule, Select],
    template: `
        <p-select 
            [ngModel]="selectedItem()"
            [id]="parameterKey()"
            [options]="parameterOptions().options"
            optionLabel="label"
            optionValue="value"
            [placeholder]="parameterDefinition().placeholder"
            [showClear]="true"

            [disabled]="isDisabled()"
            [invalid]="isInvalid()"

            fluid

            (ngModelChange)="onSelectedItemChange($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SelectParameterComponent,
            multi: true
        }
    ]
})
export class SelectParameterComponent extends ReportParameterBase<unknown, SelectParameterOptions> {
    selectedItem = signal<unknown>(null);

    onSelectedItemChange(selectedItem: unknown) {
        this.selectedItem.set(selectedItem);

        this.reportWorkspace.setParam(this.parameterKey(), selectedItem);

        this.onChange(selectedItem);
        this.markTouchedIfNotResetting();
    }

    // CVA callbacks
    writeValue(obj: unknown): void {
        this.selectedItem.set(obj);
    }
}
